import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import ActivationGroupsDataGrid from '@/features/activationGroup/components/ActivationGroupsDataGrid'
import { PortfolioHierarchyRouteInformation } from '@/features/portfolioHierarchy/constants'
import { usePortfolioHierarchyLayout } from '@/features/portfolioHierarchy/PortfolioHierarchyLayout'

function ActivationGroupsIndex() {
  const { t } = useTranslation()
  const { setPageConfig } = usePortfolioHierarchyLayout()

  useEffect(() => {
    setPageConfig({
      title: t('component.page_header.activation_groups'),
      breadcrumbs: [
        {
          text: t('component.page_header.portfolio_hierarchy'),
          to: PortfolioHierarchyRouteInformation.INDEX.navigationPath,
        },
      ],
      pageTag: 'activation_groups',
      activeTab: PortfolioHierarchyRouteInformation.ACTIVATION_GROUPS.navigationPath,
    })
  }, [])

  return <ActivationGroupsDataGrid />
}

export default ActivationGroupsIndex
